module.exports = __webpack_public_path__ + "img/ic-clover.ec9c656b.png";